import {
  FetchAddTrustedPersonSuccessAction,
  FetchDeleteTrustedPersonSuccessAction,
  FetchTrustedPersonByPinFailureAction,
  FetchTrustedPersonByPinRequestAction,
  FetchTrustedPersonByPinSuccessAction,
  FetchTrustedPersonFailureAction,
  FetchTrustedPersonRequestAction,
  FetchTrustedPersonSuccessAction,
  SalaryCardActions,
  SalaryCardActionTypes,
  TrustedPersonType,
} from 'store/types/salaryCard'
import { Dispatch } from 'redux'
import { getTrustedPersonList, updateTrustedPersonList, deleteTrustedPersonList, getTrustedPersonByPin } from '../../../services/SalaryCards/TrustedPersons';
import { setGlobalErrorAction } from '../globalError';
import { GlobalErrorActions } from 'store/types/globalError';

export const fetchTrustedPersonsRequest =
  (): FetchTrustedPersonRequestAction => ({
    type: SalaryCardActionTypes.FETCH_TRUSTED_PERSON_REQUEST,
  })

export const fetchTrustedPersonsSuccess = (
  trustedPersonList: TrustedPersonType[]
): FetchTrustedPersonSuccessAction => ({
  type: SalaryCardActionTypes.FETCH_TRUSTED_PERSON_SUCCESS,
  payload: trustedPersonList,
})

export const fetchAddTrustedPersonsSuccess = (
  trustedPerson: TrustedPersonType
): FetchAddTrustedPersonSuccessAction => ({
  type: SalaryCardActionTypes.FETCH_UPDATE_TRUSTED_PERSON_SUCCESS,
  payload: trustedPerson,
})

export const fetchDeleteTrustedPersonsSuccess = (
  id: number
): FetchDeleteTrustedPersonSuccessAction => ({
  type: SalaryCardActionTypes.FETCH_DELETE_TRUSTED_PERSON_SUCCESS,
  payload: { id },
})

export const fetchTrustedPersonsByPinRequest =
  (): FetchTrustedPersonByPinRequestAction => ({
    type: SalaryCardActionTypes.FETCH_TRUSTED_PERSON_BY_PIN_REQUEST,
  })

export const fetchTrustedPersonsByPinSuccess = (
  trustedPerson: TrustedPersonType
): FetchTrustedPersonByPinSuccessAction => ({
  type: SalaryCardActionTypes.FETCH_TRUSTED_PERSON_BY_PIN_SUCCESS,
  payload: trustedPerson,
})

export const fetchTrustedPersonsByPinFailure = (
  error: any
): FetchTrustedPersonByPinFailureAction => ({
  type: SalaryCardActionTypes.FETCH_TRUSTED_PERSON_BY_PIN_FAILURE,
  payload: error,
})

export const fetchTrustedPersonsFailure = (
  error: any
): FetchTrustedPersonFailureAction => ({
  type: SalaryCardActionTypes.FETCH_TRUSTED_PERSON_FAILURE,
  payload: error,
})

export const fetchTrustedPersons = () => {
  return async (dispatch: Dispatch<SalaryCardActions | GlobalErrorActions>) => {
    dispatch(fetchTrustedPersonsRequest())

    try {
      const data = await getTrustedPersonList();
      dispatch(fetchTrustedPersonsSuccess(data))
    } catch (error: any) {
      dispatch(fetchTrustedPersonsFailure(error.message))
      // dispatch(setGlobalErrorAction(error.message ?? ''));
    }
  }
}

export const fetchUpdateTrustedPerson = (req: TrustedPersonType) => {
  return async (dispatch: Dispatch<SalaryCardActions | GlobalErrorActions>) => {
    dispatch(fetchTrustedPersonsRequest())

    try {
      const data = await updateTrustedPersonList(req);
      dispatch(fetchAddTrustedPersonsSuccess(req))
    } catch (error) {
      dispatch(fetchTrustedPersonsFailure(error.message))
      dispatch(setGlobalErrorAction(error.message ?? ''));
    }
  }
}


export const fetchDeleteTrustedPerson = (id: number) => {
  return async (dispatch: Dispatch<SalaryCardActions | GlobalErrorActions>) => {
    dispatch(fetchTrustedPersonsRequest())

    try {
      await deleteTrustedPersonList(id);
      dispatch(fetchDeleteTrustedPersonsSuccess(id))
    } catch (error) {
      dispatch(fetchTrustedPersonsFailure(error.message))
      dispatch(setGlobalErrorAction(error.message ?? ''));
    }
  }
}

export const fetchTrustedPersonByPin = (pin: string) => {
  return async (dispatch: Dispatch<SalaryCardActions | GlobalErrorActions>) => {
    dispatch(fetchTrustedPersonsByPinRequest())

    try {
      const data = await getTrustedPersonByPin(pin);
      dispatch(fetchTrustedPersonsByPinSuccess(data))
    } catch (error: any) {
      dispatch(fetchTrustedPersonsByPinFailure(error.message))
    }
  }
}